class MegaMenuColumns extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.mega-menu__l2-item'));
    this.panels = Array.from(this.querySelectorAll('.mega-menu__l3-grid'));

    this.items.forEach((item) => {
      item.addEventListener('mouseenter', () => this.activate(item));
      item.addEventListener('focus', () => this.activate(item));
      item.addEventListener('click', () => this.activate(item));
    });
  }

  activate(item) {
    const target = item.getAttribute('data-target');
    this.items.forEach((el) => el.classList.toggle('is-active', el === item));
    this.panels.forEach((panel) => panel.classList.toggle('is-active', panel.id === target));
  }
}

customElements.define('mega-menu-columns', MegaMenuColumns);
